
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit } from 'vue-property-decorator';

@Component({})
export default class PostChallengeSuccess extends Vue {
  @Emit('done')
  handleSubmit() {
    return true;
  }
}
